import React from 'react';

interface PillsProps {
  variant: 'primary' | 'secondary';
  number: number | undefined;
  className?: string;
  onClick?: () => {};
}

export const Pill = ({ variant, number, className, onClick }: PillsProps) => {
  /* Checking for missing required props */
  // if (!variant)
  //   throw new Error(
  //     `You need to pass a prop called "variant" of type 'primary' | 'secondary' to the Pills component. To learn more about the list of required props for the
  //     Pills component go to Maverick documentation at: https://thryvlabs-maverick.netlify.app/?path=/docs/ui-pills`
  //   );
  // if (!number && typeof number !== 'number')
  //   throw new Error(
  //     `You need to pass a prop called "number" of type number | undefined to the Pills component. To learn more about the list of required props for the
  //     Pills component go to Maverick documentation at: https://thryvlabs-maverick.netlify.app/?path=/docs/ui-pills`
  //   );
  /* Checking for missing required props */
  const renderPrimaryPill = variant === 'primary' && (
    <div
      className={`${
        number ? '' : 'hidden'
      } h-[24px] font-open-sans font-semibold text-[12px] w-[24px] bg-thryv-orange-500 rounded-3xl text-white flex justify-center items-center ${
        className || ''
      }`}
      onClick={onClick}
    >
      {number}
    </div>
  );

  const renderSecondaryPill = variant === 'secondary' && (
    <div
      className={`${
        number ? '' : 'hidden'
      } h-[24px] font-open-sans font-semibold text-[12px] w-[24px] bg-thryv-sapphire-500 rounded-3xl text-white flex justify-center items-center ${
        className || ''
      }`}
      onClick={onClick}
    >
      {number}
    </div>
  );

  return (
    <>
      {renderPrimaryPill}
      {renderSecondaryPill}
    </>
  );
};
